import React from "react";

export const KeyIcon = (props) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M8.73458 11.5156C8.15642 10.0735 8.09391 8.47605 8.55762 6.9932C9.02133 5.51034 9.98281 4.23307 11.2795 3.37727C12.5763 2.52148 14.1287 2.13967 15.6745 2.29636C17.2202 2.45306 18.6644 3.13865 19.7631 4.23726C20.8617 5.33588 21.5473 6.78012 21.7039 8.32586C21.8606 9.87161 21.4788 11.4241 20.623 12.7208C19.7672 14.0175 18.49 14.979 17.0071 15.4427C15.5242 15.9064 13.9268 15.8439 12.4847 15.2657L12.4847 15.2656L11.2502 16.5001H9.00024V18.7501H6.75024V21.0001H3.00024V17.2501L8.73474 11.5156L8.73458 11.5156Z"
        stroke={!!props.stroke ? props.stroke : "#F0AF42"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.875 8.625C17.7034 8.625 18.375 7.95343 18.375 7.125C18.375 6.29657 17.7034 5.625 16.875 5.625C16.0466 5.625 15.375 6.29657 15.375 7.125C15.375 7.95343 16.0466 8.625 16.875 8.625Z"
        fill={!!props.fill ? props.fill : "#F0AF42"}
      />
    </svg>
  );
};
